import swaggerDiff from './workflow';
import defaultConfig from './defaultConfig';

swaggerDiff.defaultConfig = defaultConfig;
export default swaggerDiff;



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/